import { SLOTS } from './slots.js'

// College towns (areas). Simple scalar entity; primary links to the edit page.
export default {
  key: 'college_town',
  label: 'College Town',
  icon: 'college_towns',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'name', link: 'url' },
    { slot: SLOTS.STATUS, field: 'social_enabled', label: 'Social', renderer: 'toggle' },
    { slot: SLOTS.METADATA, field: 'address', label: 'Address' },
    { slot: SLOTS.METADATA, field: 'logo_url', label: 'Logo', renderer: 'media_thumb', alt: 'Logo' }
  ],
  empty: { icon: 'college_towns', message: 'No college towns yet.' },
  defaultView: 'table',
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
